import React, {useState} from 'react';
import _ from 'lodash';
import K from '../k';

const Radio = ({label, disabled, checked, onChange, style, labelStyle, containerStyle}) => {
  //HINT determines whether or not component should be managed locally.
  //When isControlled is true, behavior is only driven by props.
  const isControlled = checked !== undefined;
  const [isChecked, setIsChecked] = isControlled ? [checked, null] : useState(false);

  const styles = {
    radioContainer: {display: 'flex', alignItems: 'center', ...containerStyle},
    radio: {
      width: 16.5,
      height: 16.5,
      margin: 0,
      color: isChecked ? K.colors.active : K.colors.doubleGray,
      borderColor: isChecked ? K.colors.active : K.colors.doubleGray,
      ...disabled ? {...K.disabled, color: K.colors.gray, borderColor: K.colors.gray} : {},
      ...style,
    },
    radioLabel: {
      marginLeft: K.spacing / 4,
      ...K.fonts.label,
      ...labelStyle
    }
  };

  const handleChange = (e) => {
    if (!isControlled) setIsChecked((e.target.checked));

    if (onChange) onChange(e.target.checked);
  };

  return (
    <div style={styles.radioContainer}>
      <input
        {...{disabled}}
        type={'radio'}
        style={styles.radio}
        onChange={handleChange}
        checked={isChecked}
      />
      {label && <span style={styles.radioLabel}>{label}</span>}
    </div>
  );
};

const RadioGroup = ({defaultValue, disabled = false, options, onChange, radioStyle, labelStyle, style, value}) => {
  const isControlled = value !== undefined;
  const [checkedValue, setCheckedValue] = isControlled ? [value, null] : useState(defaultValue);

  const handleRadioChange = (value) => {
    if (!isControlled) {
      if (checkedValue !== value) setCheckedValue(value);
      else if (checkedValue === value) setCheckedValue(null);
    }

    if (onChange) onChange(value);
  };

  return (<div {...{style}}>
    {_.map(options, option => (
      <Radio
        {...{...option}}
        key={option.value}
        style={radioStyle}
        labelStyle={labelStyle}
        disabled={disabled ? disabled : option.disabled}
        checked={checkedValue === option.value}
        onChange={() => handleRadioChange(option.value)}
      />
    ))}
  </div>);
};

export {RadioGroup, Radio};